var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 1.73494C36.2967 1.73494 46.2651 11.7033 46.2651 24C46.2651 36.2967 36.2967 46.2651 24 46.2651C11.7033 46.2651 1.73494 36.2967 1.73494 24C1.73494 11.7033 11.7033 1.73494 24 1.73494Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7653 25.5437L13.6986 25.6339C13.3187 26.2176 13.7317 27.0219 14.4576 27.0219H22.9788L22.0453 34.4908C21.9337 35.3838 23.0558 35.8708 23.6319 35.1795L34.2343 22.4566L34.3009 22.3665C34.6808 21.7828 34.2678 20.9785 33.542 20.9785H25.0197L25.9543 13.5096C26.0659 12.6166 24.9438 12.1295 24.3677 12.8208L13.7653 25.5437ZM23.7846 16.3357L23.1055 21.7679L23.0984 21.8821C23.0988 22.3713 23.4964 22.7809 23.9998 22.7809H31.6176L24.215 31.6636L24.894 26.2324L24.9011 26.1183C24.9007 25.6291 24.5031 25.2195 23.9998 25.2195H16.3809L23.7846 16.3357Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugins);
export default __webpack_public_path__ + "static/media/plugins.2f1d53fcdfb51c1938aa9dbc8c12525b.svg";
export { ForwardRef as ReactComponent };